import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { RequiredActions } from "@authzsvc/common-react-components";
import { setBreadcrumbs } from "../../actions";
import { useNavigate } from "react-router";

const RequiredActionsWrapper = ({
  // actions
  setBreadcrumbs,
  breadcrumbs,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [setBreadcrumbs, breadcrumbs]);

  const handleSelect = (request) => {
    if (request) {
      navigate(`/required-actions/${request.id}`);
    }
  };

  return <RequiredActions onSelect={(request) => handleSelect(request)} />;
};

RequiredActionsWrapper.propTypes = {
  setBreadcrumbs: PropTypes.func.isRequired,
  breadcrumbs: PropTypes.array,
};

export default connect(null, {
  setBreadcrumbs,
})(RequiredActionsWrapper);
